import styles from './FJTextBaseEditAudioRight.module.less';
import FJPurpleMusicSvg from '../../../../assets/svg/purple-music.svg?react';

const FJTextBaseEditAudioRight = props => {
    const { onClick } = props;
    return (
        <div className={styles.container} onClick={onClick}>
            <FJPurpleMusicSvg />
        </div>
    );
};

export default FJTextBaseEditAudioRight;
